"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
// TODO: find correct event type
var onClick = function (props) { return function (event) {
    if (event.target instanceof Element) {
        if (event.target.classList.contains('sok-overlay-container')) {
            props.onClose && props.onClose(event);
        }
    }
}; };
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Overlay'), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (next) {
        if (next.isOpen) {
            document.body.style.overflowY = 'hidden';
        }
        else {
            document.body.style.overflowY = '';
        }
    }
}), (0, recompose_1.withHandlers)({
    onClick: onClick
}), recompose_1.toClass);
exports.Overlay = enhance(function (_a) {
    var className = _a.className, isOpen = _a.isOpen, containerClass = _a.containerClass, children = _a.children;
    return (React.createElement("div", { className: classNames('sok-overlay', className) },
        isOpen && (React.createElement("div", { className: classNames('sok-overlay-container', containerClass) })),
        children));
});
//# sourceMappingURL=index.js.map